<template>
  <div class="loader">
    <img :src="require('@/assets/loader.gif')" />  
  </div>  
</template>

<script>
export default {

}
</script>

<style>

</style>